import { AppThunkAction } from 'models/Store';

import { selectCurrentArticleIndex } from './consignmentSwitcher.selectors';
import { setCurrentArticleIndex } from './consignmentSwitcher.slice';

export const nextArticle =
  (articleSize: number): AppThunkAction =>
  (dispatch, getState) => {
    const state = getState();
    const currentArticleIndex = selectCurrentArticleIndex(state);

    if (!articleSize || articleSize === 1) return;
    const newArticleIndex = currentArticleIndex + 1;
    if (newArticleIndex < articleSize) {
      dispatch(updateCurrentArticleIndex(newArticleIndex));
    } else {
      dispatch(updateCurrentArticleIndex(0));
    }
  };

export const previousArticle =
  (articleSize: number): AppThunkAction =>
  (dispatch, getState) => {
    const state = getState();
    const currentArticleIndex = selectCurrentArticleIndex(state);

    if (!articleSize || articleSize === 1) return;
    if (currentArticleIndex > 0) {
      dispatch(updateCurrentArticleIndex(currentArticleIndex - 1));
    } else {
      dispatch(updateCurrentArticleIndex(articleSize - 1));
    }
  };

export const updateCurrentArticleIndex =
  (index: number): AppThunkAction =>
  (dispatch) => {
    dispatch(setCurrentArticleIndex(index));
  };
